import { render } from "./UserDialog.vue?vue&type=template&id=5b2ff5e2&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"

import "./UserDialog.vue?vue&type=style&index=0&id=5b2ff5e2&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2ff5e2"]])

export default __exports__